/* unplugin-vue-components disabled */import { render } from "./tips.vue?vue&type=template&id=1ab676d1&scoped=true&ts=true"
import script from "./tips.vue?vue&type=script&lang=ts"
export * from "./tips.vue?vue&type=script&lang=ts"

import "./tips.vue?vue&type=style&index=0&id=1ab676d1&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab676d1"]])

export default __exports__